import _get from 'lodash/get';
import { HR_APPROVAL_STATUSES } from '../../utils/constants';

export function acceptedQuoteId(state) {
  return _get(state.application, 'metaData.acceptedQuote.id');
}

export function pendingApprovals(state) {
  const approvals = state.approvals || [];
  return approvals.filter(
    (approval) =>
      approval.approvalStatus === HR_APPROVAL_STATUSES.pending.hrApproval
  );
}
